import Col               from 'antd/lib/col';
import Row               from 'antd/lib/row';
import classNames        from 'classnames';
import HelpIcon          from 'components/HelpIcon';
import Value             from 'components/Value';
import { IValueProps }   from 'components/Value';
import View              from 'components/View';
import React             from 'react';
import { CSSProperties } from 'react';
import './GridInfo.scss';

export interface IGridInfoItem extends IValueProps {
	empty?: boolean;
	help?: React.ReactNode;
	hidden?: boolean | ((column: IGridInfoItem) => boolean);
	label?: React.ReactNode;
	link?: string;
	loading?: boolean;
	style?: CSSProperties;
}

export interface IGridInfoProps {
	className?: string;
	data: IGridInfoItem[][];
	labelVertical?: boolean;
	spaceVertical?: number;
	style?: CSSProperties;
}

export default React.forwardRef((props: IGridInfoProps, ref: React.LegacyRef<HTMLDivElement>) => {
	const { className, data, labelVertical, style } = props;

	const columns = data.map((column, colKey) => {
		return (
			<Col flex={1} key={colKey}>
				<div className="GridInfo__table">
					{column
						.filter(item => typeof item.hidden === 'function' ? !item.hidden(item): !item.hidden)
						.map((item, itemKey) => {

							const { help, label } = item;

							return (
								<div key={itemKey}>

									{
										label && <View 
											flex 
											gap={5} 
											row
										>
											<span className="GridInfo__label">{item.label}</span>
											{help && <HelpIcon text={help} />}
										</View>
									}

									<div>
										{renderValue(item)}
									</div>
								</div>
							);
						}
						)}
				</div>
			</Col>
		);
	});

	return (
		<div className={classNames('GridInfo', className, { labelVertical })} ref={ref} style={style}>
			<Row gutter={[20, 20]} style={{ flex: 1 }}>
				{columns}
			</Row>
		</div>
	);
});

const renderValue = (item: IGridInfoItem) => {
	return (
		<Value
			empty={item.empty}
			link={item.link}
			linkTarget={item.linkTarget}
			loading={item.loading}
			style={item.style}
			type={item.type}
			value={item.value}
		/>
	);
};